export const TRANSLATIONS_EN = {
    header_menu_home:"Home",
    header_menu_schoolexamfees:"Tuition/Exam Fees",
    header_menu_paymentschoolexamfees:"Tuitions/Exams fees payement",
    header_menu_paymentschoolexamfees_description:"Fill out this form to pay your tuition or exam fees",
    header_menu_findpayment:"Find payment",
    consulter_paiement:"Find payment",
    consulter_paiement_description:"To view payment information, please enter the reference and validate",
    header_menu_searchcode:"Code search",
    header_menutop_espaceclient:"Support",
    header_menutop_assistance:"Assistance",
    header_menutop_pointvente:"Sales points",
    header_menutop_business:"Business",
    header_menutop_particular:"Particulier",
    header_menu_followus:"Follow us",
    header_menu_aboutocm:"About Orange Cameroun",
    header_menu_mentionlegal:"Legal notice",
    header_menu_ocmfoundation:"Orange foundation",
    page_welcome_paiementscolaritexamen:"Tuition & Exam Payment",
    page_welcome_feescolaritexamen:"Tuition & Exam Fees",
    page_welcome_payfeescolaritexamen:"Payer frais scolaire/Examen",
    page_welcome_feescolaritexamen_description:"Make the payment of tuition or exams of schools",
    page_welcome_title_description:"Welcome to the Orange Money School Fees payment portal.<br/>Accessible 7 days a week, 24 hours a day from your computer, mobile or tablet, this dedicated space allows you to carry out your school fee payment transactions at any time in complete autonomy and security.",
    header_menu_findapayment:"Find a payment",
    header_menu_findapayment_description:"View and print tuition / exam payment receipts",
    header_menu_getschoolcode:"Get the school code",
    header_menu_getschoolcode_cardtext:"To search for a school code, please enter the name and validate",
    header_menu_getcode:"Get code",
    header_menu_getschoolcode_description:"Search for schools, their classes and exams available",
    header_menu_getinfospaymenttuitionexam:"Obtain payment information for school fees",
    header_menu_getinfospaymenttuitionexam_description:"You paid your tuition fees with Orange Money. Thank you for your confidence.<br/><br/>To obtain the receipt of your payment of school fees",
    cliquerici:"click here",
    region:"State",
    departement:"Division",
    arrondissement:"Sub Division",
    select_region:"Select the region",
    select_departement:"Select the division",
    select_arrondissement:"Select the sub division",
    liste_etablissements:"List of schools",
    noschool_toshow:"No school to display at the moment",
    goback_home:"Return to home",
    details_etablissement:"School details",
    etablissement:"School",
    code:"Code",
    copier:"Copy",
    genre:"Gender",
    classes_disponible:"Available classes",
    examens:"Exams",
    fermer:"Close",
    valider:"Validate",
    reference_payment:"Payment reference",
    feedback_reference_payment:"Please fill in the payment reference",
    impossible_tofindschoolinfos:"Unable to retrieve school information.",
    entrer_reference_paiement:"Enter the payment reference number",
    imprimer:"Print",
    montant:"Amount",
    produit_achete:"Product purchased",
    id_transaction:"Transaction ID",
    datepaiement:"Payment date",
    matricule:"Registration number",
    prenom:"Surname",
    nom:"Name",
    label_produit:"Product",
    label_etablissement:"School",
    label_examen:"Exam",
    label_classe:"Classe",
    label_fraisscolarite:"Tuition fees",
    label_fraisexamen:"Official exam fees",
    feedback_choisirproduit:"Please choose the product",
    feedback_selectetablissement:"Please select the school",
    feedback_selectclasse:"Please select the class",
    feedback_selectexam:"Please select the exam",
    placeholder_nometablissement:"Enter the school name",
    placeholder_referencepaiement:"Enter the payment reference",
    placeholder_selectexam:"Select the exam",
    placeholder_selectclasse:"Select the class",
    label_studentlastname:"Student last name",
    label_studentfirstname:"Student first name",
    label_studentbirthdate:"Student birth date",
    label_sexe:"Gender",
    label_feminin:"Female",
    label_masculin:"Male",
    label_payer:"Pay",
    label_payerphonenumber:"Payer's phone number",
    label_parentphonenumber:"Parent's phone number",
    label_noschoolfound:"No school found for",
    placeholder_enterstudentlastname:"Enter the student's last name",
    feedback_enterstudentlastname:"Please enter the student's last name",
    placeholder_enterstudentfirstname:"Enter the student's first name",
    placeholder_selectstudentbirthdate:"Select the student's birth date",
    placeholder_enterpayerphonenumber:"Enter the payer's phone number",
    placeholder_enterparentphonenumber:"Enter the parent's phone number",
    feedback_enterstudentfirstname:"Please enter the student's first name",
    feedback_selectstudentbirthdate:"Please select the student's birth date",
    feedback_selectsexe:"Please select gender",
    feedback_enterpayerphonenumber:"Please enter the payer's phone number",
    feedback_enterparentphonenumber:"Please enter parent's phone number",
    servererror_savepayment:"Unable to save your payment. please try again later",
    label_recapitulatifpaiement:"Payment summary",
    label_pleasewait:"Please wait",
    label_frais:"fees",
    label_amount:"Amount",
    confirmer:"Confirm",
    label_requete_encourenregistrement:"Your request is being recorded. Please do not leave this page",
    label_paiementenregistre:"Payment saved",
    label_paiementenregistresucces:"Payment saved successfully",
    label_paiementfailed:"Payment fail",
    message_paymentsubmitted:"Student registration STUDENT_LASTNAME STUDENT_FIRSTNAME in SCHOOL_NAME for an amount of PAYMENT_AMOUNT is being processed. You will receive a confirmation by SMS on the number PAYER_PHONE",
    erreur:"Error",
    recu_paiement:"Receipt Payment",
    service_indisponible:"Service unavailable. Please try again later",
    recu_paiementfrais:"Receipt Payment fees",
    label_date:"Date",
    reference_paiement:"Payment reference",
    erreur_paiement:"Payment error",
    echec_operation_veuillezreessayer:"Operation failed, please try again later.",
};
